import { TabPanel } from '@mui/lab';
import { IconButton } from '@mui/material';
import { Box } from '@mui/system';
import styled from 'styled-components';

export const ChartsContent = styled(Box)`
  background-color: ${({ theme }) => theme.palette.grey[100]};
  height: calc(100% - 201px);
  padding: 20px;
  overflow-y: scroll;
  position: relative;
`;

export const TabPanelCustom = styled(TabPanel)`
  display: flex;
  flex-direction: column;
  gap: 48px;
`;

export const NoDataIcon = styled(IconButton)`
  color: ${({ theme }) => theme.palette.primary[400]};
  background-color: ${({ theme }) => theme.palette.primary[100]};
  border: 8px solid ${({ theme }) => theme.palette.primary[50]};
  border-radius: 50%;
  cursor: initial;
`;

export const NoDataWrapper = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  height: 100%;
`;

export const DataHeading = styled(Box)`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 24px;
  gap: 39px;
`;
